import ICPemasukan2 from 'assets/icons/pemasukan-2.svg'
import ICPengeluaran2 from 'assets/icons/pengeluaran-2.svg'
import 'assets/scss/flatpickr/flatpickr.scss'
import { P } from 'components'
import PMBPagination from 'components/PMBPagination'
import { TableComponent as DataTable } from 'components/TableComponent'
import { capitalizeEveryWord, generateUniqueId } from 'helpers'
import moment from 'moment-timezone'
import { useSnackbar } from 'notistack'
import { useEffect, useState } from 'react'
import { Calendar, ChevronDown, Info } from 'react-feather'
import Flatpickr from 'react-flatpickr'
import { useDispatch, useSelector } from 'react-redux'
import {
  Button,
  Card,
  CardBody,
  Col,
  Modal,
  ModalBody,
  Row,
  Spinner,
} from 'reactstrap'
import { formatDatePMB } from 'utils/formatDate'
import { newFormatThousandSeparator } from 'utils/formatNumber'
import {
  useAddReportMutation,
  useLazyFetchLedgerQuery,
} from './reportPnbpListApiSlice'
import {
  setDateLedger,
  setFetchOptionLedger,
  setFiltersLedger,
} from './reportPnbpListSlice'

const ModalLedger = ({
  isOpen,
  toggle,
  id,
  dataConfig,
  dataReports,
  refetch,
}) => {
  const { enqueueSnackbar } = useSnackbar()
  const [fetchLedger, res] = useLazyFetchLedgerQuery()
  const [addReport, { isLoading: isLoadingAddReport }] = useAddReportMutation()

  const [data, setData] = useState([])
  const [selectedRow, setSelectedRow] = useState([])

  const dispatch = useDispatch()
  const { selectedDate, selectedFilter } = useSelector(
    (s) => s.reportPnbp.filtersLedger,
  )
  const { tagLedger } = useSelector((s) => s.reportPnbp)
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 768)

  // HANDLE IS MOBILE
  useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth <= 768)
    window.addEventListener('resize', handleResize)
    return () => window.removeEventListener('resize', handleResize)
  }, [])

  const handleDateChange = (dates) => {
    const startDate = moment(dates[0]).format('YYYY-MM-DD')
    const endDate = moment(dates[1]).format('YYYY-MM-DD')
    dispatch(
      setFiltersLedger({
        selectedDate: [startDate, endDate],
      }),
    )
  }

  const columns = [
    {
      name: <span>Tanggal</span>,
      wrap: true,
      grow: isMobile ? 2 : 1,
      cell: (row) =>
        formatDatePMB(
          `${row?.createddate + ' ' + row?.createdhour}`,
          `${row?.createddate + ' ' + row?.createdhour}`,
        ),
    },
    {
      name: <span>Kategori</span>,
      grow: isMobile ? 2 : 1,
      width: isMobile && '20%',
      cell: (row) => (
        <div className="d-flex gap-2 align-items-center fw-500">
          <img
            width={28}
            height={28}
            src={
              row?.incomeorexpense === 'income' ? ICPemasukan2 : ICPengeluaran2
            }
            alt={
              row?.incomeorexpense === 'income' ? 'Pemasukan' : 'Pengeluaran'
            }
          />
          <span>{row?.label}</span>
        </div>
      ),
    },
    {
      name: <span>Jenis Catatan</span>,
      wrap: true,
      grow: isMobile ? 2 : 1,
      cell: (row) => {
        return (
          <div
            className={`badge rounded-pill ${row?.subType.toLowerCase() === 'sistem transaksi' ? 'bg-warning-50 text-warning-700' : row?.subType.toLowerCase() === 'catat manual' ? 'bg-gray-100 text-gray-700' : 'bg-danger-50 text-danger-700'}`}
          >
            {row?.subType}
          </div>
        )
      },
    },
    {
      name: <span>Dari/Ke</span>,
      grow: 2,
      cell: (row) => <span>{row?.extradata?.picname ?? 'PasarMIKRO'}</span>,
    },
    {
      name: <span>Barang</span>,
      grow: 2,
      cell: (row) => {
        const items = row?.extradata?.items
        const normalizedItems = Array.isArray(items)
          ? items
          : items
            ? [items]
            : []

        const isSelected = selectedRow?.some((r) => r?.id === row?.id)

        return (
          <ul style={{ padding: 4, margin: 0 }}>
            {normalizedItems.map((item, i) => {
              const isValid = dataConfig?.some((config) =>
                config?.commodities?.some(
                  (commodity) =>
                    commodity?.commodity?.id === item?.itemId &&
                    commodity?.commodity?.unit?.toLowerCase() ===
                      item?.unit?.toLowerCase(),
                ),
              )

              const shouldMarkInvalid = isSelected && !isValid

              return (
                <li
                  key={i}
                  style={{
                    color: shouldMarkInvalid ? '#999' : 'inherit',
                    fontStyle: shouldMarkInvalid ? 'italic' : 'normal',
                  }}
                >
                  {item?.name || '-'} {item?.amount || '0'}{' '}
                  {item?.unit && item?.unit !== 'null'
                    ? capitalizeEveryWord(item?.unit)
                    : ''}
                  {shouldMarkInvalid && ' - Tidak terdaftar'}
                </li>
              )
            })}
          </ul>
        )
      },
    },
    {
      name: (
        <div
          style={{
            textAlign: 'right',
            width: '100%',
            display: 'flex',
            justifyContent: 'flex-end',
          }}
        >
          Jumlah
        </div>
      ),
      wrap: true,
      grow: 2,
      cell: (row) => (
        <div className="d-flex justify-content-end w-100">
          <span>
            Rp
            {newFormatThousandSeparator(row?.amount, 0)}
          </span>
        </div>
      ),
    },
  ]

  useEffect(() => {
    dispatch(
      setDateLedger({
        startdate: moment(selectedDate[0]).format('YYYY-MM-DD'),
        enddate: moment(selectedDate[1])
          .local()
          .add(1, 'days')
          .format('YYYY-MM-DD'),
      }),
    )
    fetchLedger({
      startdate: moment(selectedDate[0]).format('YYYY-MM-DD'),
      enddate: moment(selectedDate[1])
        .local()
        .add(1, 'days')
        .format('YYYY-MM-DD'),
      // filter: selectedFilter?.value,
      page: tagLedger?.page,
      size: tagLedger?.size,
    })
      .unwrap()
      .then((resAPI) => {
        setData(resAPI)
      })
      .catch((e) => {
        if (
          e.response &&
          e.response.status === 403 &&
          typeof e.response.data.message !== 'undefined' &&
          e.response.data.message === 'access denied'
        ) {
          console.warn(e)
        }
        console.warn(e)
      })
  }, [selectedDate, selectedFilter, tagLedger])

  const handleMergeToReportDetail = async () => {
    try {
      const newData = selectedRow?.flatMap((row) => {
        return (
          row?.extradata?.items
            ?.filter((item) => {
              return dataConfig?.some((config) =>
                config?.commodities?.some(
                  (commodity) =>
                    commodity?.commodity?.id === item?.itemId &&
                    commodity?.commodity?.unit?.toLowerCase() ===
                      item?.unit?.toLowerCase(),
                ),
              )
            })
            ?.map((item) => {
              const matchedConfig = dataConfig?.find((config) =>
                config?.commodities?.some(
                  (commodity) =>
                    commodity?.commodity?.id === item?.itemId &&
                    commodity?.commodity?.unit?.toLowerCase() ===
                      item?.unit?.toLowerCase(),
                ),
              )

              const matchedCommodity =
                matchedConfig?.commodities?.find(
                  (commodity) => commodity?.commodity?.id === item?.itemId,
                ) || null

              return {
                id: generateUniqueId(),
                type: {
                  label: matchedConfig?.type,
                  value: matchedConfig?.type,
                },
                commodity: {
                  // Pastikan struktur sesuai dengan data Alpukat
                  commodity: {
                    value: matchedCommodity?.commodity?.id,
                    label: matchedCommodity?.commodity?.label,
                    id: matchedCommodity?.commodity?.id,
                    image: matchedCommodity?.commodity?.image,
                    sku: matchedCommodity?.commodity?.sku,
                    unit: matchedCommodity?.commodity?.unit,
                  },
                  label: matchedCommodity?.commodity?.label,
                  value: matchedCommodity?.commodity?.label,
                  psdh: matchedCommodity?.psdh,
                  unit: matchedCommodity?.unit,
                  id: matchedCommodity?.id,
                },
                psdh: matchedCommodity?.psdh,
                unit: matchedCommodity?.unit,
                volume: item?.amount,
                total: item?.amount * (matchedCommodity?.psdh ?? 0),
              }
            }) || []
        )
      })

      // INSERT TO REPORT BASED ON ID
      const updatedReports = dataReports?.map((report) => {
        if (report.id === id) {
          return {
            ...report,
            itemConfigurations: [
              ...(newData || []),
              ...(report.itemConfigurations || []),
            ],
          }
        }
        return report
      })

      const response = await addReport(updatedReports)
      if (response && response?.data) {
        enqueueSnackbar('Data arus kas berhasil ditambahkan', {
          variant: 'success',
        })
        refetch()
        toggle()
        setSelectedRow([])
      }
    } catch (error) {
      enqueueSnackbar(
        error?.data?.message ?? 'Data arus kas gagal ditambahkan',
        {
          variant: 'error',
        },
      )
    }
  }

  const isItemValid = (item) => {
    return dataConfig?.some((config) =>
      config?.commodities?.some(
        (commodity) =>
          commodity?.commodity?.id === item?.itemId &&
          commodity?.commodity?.unit?.toLowerCase() ===
            item?.unit?.toLowerCase(),
      ),
    )
  }

  return (
    <>
      <Modal
        className="p-4"
        centered
        isOpen={isOpen}
        toggle={toggle}
        autoFocus={false}
        style={{
          maxWidth: '100%',
          minWidth: '100%',
          height: '600px',
          overflow: 'auto',
          borderRadius: '10px',
        }}
        data-testid="pnbp-modal-ledger"
      >
        <ModalBody>
          <div className="mb-2 d-flex flex-column gap-3">
            <Card className="border-0 shadow-none">
              <CardBody>
                <Row className="align-items-center gy-2">
                  <Col xs={12} md="auto" className="order-md-1">
                    <h5 className="fw-semibold mb-0">Riwayat Arus Kas</h5>
                  </Col>
                </Row>

                {/* FILTER */}
                <Col xs="12">
                  <div className="d-flex flex-column flex-md-row align-items-center justify-content-center justify-content-md-start gap-3 w-100 my-4">
                    <div
                      className="w-100"
                      style={{ maxWidth: isMobile ? '100%' : '260px' }}
                    >
                      <p className="mb-2">Tanggal</p>
                      <div className="d-flex align-items-center border rounded">
                        <Calendar size={17} className="ms-3 flex-shrink-0" />
                        <Flatpickr
                          options={{
                            mode: 'range',
                            dateFormat: 'd-m-Y',
                            defaultDate: selectedDate,
                            onClose: handleDateChange,
                            maxDate: new Date(),
                            disableMobile: true,
                          }}
                          className="form-control flat-picker bg-transparent border-0 shadow-none w-100"
                        />
                      </div>
                    </div>
                  </div>
                </Col>

                <div className="d-flex align-items-center gap-2 p-2 bg-gray-100 rounded-2">
                  <Info size={16} color="#006386" />
                  <P size="small">
                    Barang yang dapat ditambahkan hanya yang terdaftar pada
                    konfigurasi
                  </P>
                </div>

                <Card className="border-0 shadow-none pt-2">
                  <DataTable
                    selectableRows={true}
                    selectableRowDisabled={(row) => {
                      const items = row.extradata?.items || []
                      return !items.some(isItemValid)
                    }}
                    onSelectedRowsChange={(e) => {
                      const validRows = e.selectedRows.filter((row) => {
                        const items = row.extradata?.items || []
                        return items.some(isItemValid)
                      })

                      setSelectedRow([...validRows])
                    }}
                    fixedHeader
                    fixedHeaderScrollHeight="400px"
                    columns={columns}
                    data={data?.items}
                    pagination
                    paginationServer
                    sortServer
                    responsive
                    persistTableHead
                    progressPending={res?.isFetching}
                    progressComponent={
                      <div style={{ margin: '100px 0px' }}>
                        <Spinner color="primary" />
                      </div>
                    }
                    sortIcon={<ChevronDown />}
                    paginationComponent={(props) => (
                      <PMBPagination
                        rowCount={data?.totalItems || 0}
                        currentPage={tagLedger?.page}
                        rowsPerPage={tagLedger?.size}
                        setCurrentPage={(e) => {
                          dispatch(setFetchOptionLedger({ page: e }))
                        }}
                        setRowsPerPage={(e) => {
                          dispatch(setFetchOptionLedger({ size: e }))
                        }}
                        props={props}
                      />
                    )}
                  />
                </Card>
              </CardBody>
            </Card>
          </div>

          <div className="d-flex gap-3 mt-3 justify-content-end">
            <Button
              onClick={() => {
                toggle()
                setSelectedRow([])
              }}
              className="btn-cancel"
              outline
              data-testid="pnbp-modal-ledger-cancel"
              {...(isMobile && { block: true })}
            >
              Batal
            </Button>
            <Button
              color="primary"
              disabled={isLoadingAddReport || !selectedRow?.length}
              onClick={handleMergeToReportDetail}
              data-testid="pnbp-modal-ledger-submit"
              {...(isMobile && { block: true })}
            >
              {isLoadingAddReport && <Spinner size="sm" className="me-2" />}
              Tambah
            </Button>
          </div>
        </ModalBody>
      </Modal>
    </>
  )
}

export default ModalLedger
